<template>
  <div class="progress-container">
    <div class="spin-lg" />
  </div>
</template>
<script>
export default {};
</script>
